<template>
  <div class="modal-card">
    <div class="row-width-actions-bar">
      <div class="columns is-gapless is-vcentered is-border-bottom">
        <div class="column is-padding-left">
          <div class="has-text-dark is-size-6 is-uppercase">
            <span class="has-text-weight-medium">GESTION RECOMMANDÉ</span>
          </div>
        </div>
        <div class="column is-narrow is-border-left">
          <a
            class="page-header-btn is-small is-square"
            @click="close">
            <span class="icon is-size-4 has-text-dark"><i class="fal fa-times"></i></span>
          </a>
        </div>
      </div>
    </div>
    <section class="modal-card-body is-paddingless">
      <component
        :is="sruComponents[currentSru]"
        :request-elem="requestElem"
        :buyer-pk="buyerPk"
        :lre="lre"
        :appel-de-fond-index="appelDeFondIndex"
        :from="from"
        :sru-index="sruIndex"
        @sendInfo="sendInfo"
        @goToDemat="goToDemat"
        @close="close"
        @changeModal="changeModal">
      </component>
    </section>
    <!-- <div class="formActionsSticky is-bottom">
      <div class=" columns is-gapless is-centered has-background-white is-padding-top-small is-padding-bottom-small">
        <div class="column is-4 is-3-widescreen is-margin-right-small">
          <a @click="close()" class="button is-light is-uppercase is-fullwidth">
            <span>Annuler</span>
          </a>
        </div>
        <div class="column is-4 is-3-widescreen is-margin-left-small">
          <button @click="submit" class="button is-success is-uppercase is-fullwidth has-text-white" type="submit">
            <span>Valider</span>
          </button>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
const SRU_COMPONENTS = Object.freeze({
  registered: 'RegisteredMail',
  demat: 'DematSru',
  before: 'BeforeDematSru'
})
export default {
  name: 'RecommendedManagement',
  components: {
    RegisteredMail: () => import('../adv/FeuilleDeRoute/sru/RegisteredMail'),
    DematSru: () => import('../adv/FeuilleDeRoute/sru/DematSru'),
    BeforeDematSru: () => import('../adv/FeuilleDeRoute/sru/BeforeDematSru')
  },
  props: {
    active: {
      type: Boolean,
      required: true
    },
    params: {
      type: Object
    }
  },
  data () {
    return {
      lre: null,
      currentSru: null,
      sruComponents: SRU_COMPONENTS
    }
  },
  computed: {
    requestElem () {
      return this.params.requestElem
    },
    buyerPk () {
      return this.params.buyerPk
    },
    appelDeFondIndex () {
      return this.params.appelDeFondIndex
    },
    sruIndex () {
      return this.params.sruIndex
    },
    from () {
      return this.params.from
    }
  },
  created () {
    this.currentSru = this.params.currentSru
    if (this.params.lre) {
      this.goToDemat(this.params.lre)
    }
  },
  methods: {
    sendInfo (lre) {
      this.$emit('sendInfo', lre)
    },
    goToDemat (lre) {
      this.currentSru = 'demat'
      this.lre = Object.assign({}, lre)
    },
    changeModal (val) {
      this.currentSru = val
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>
